export default __webpack_public_path__ + "static/media/avatar_pyper8.b63c65c9.mp3";